var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    viewBox: "0 0 36 35",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#faf7f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.8262.460327h33.6622v7.08678h-33.6622z",
    transform: "matrix(0 1 -1 0 22.286527 -21.365873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.8262 27.0355h7.08678v7.08678h-7.08678z",
    transform: "matrix(0 1 -1 0 48.8617 5.2093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9141 19.9486h7.08678v7.08678h-7.08678z",
    transform: "matrix(0 1 -1 0 48.8627 -8.9655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.7422 19.9486h7.08678v7.08678h-7.08678z",
    transform: "matrix(0 1 -1 0 34.6908 5.2064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 12.8607h7.08678v7.08678h-7.08678z",
    transform: "matrix(0 1 -1 0 48.8607 -23.1393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.65234 12.8607h7.08678v7.08678h-7.08678z",
    transform: "matrix(0 1 -1 0 20.51304 5.20836)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8fac81dc88a1f78511743bd6575ae59e.svg";
export { ForwardRef as ReactComponent };